<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{label.reportType}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md6 lg6>
                        <v-autocomplete :items="reportTypes" v-model="form.reportType" :label="label.reportType" item-text="label" item-value="value" data-vv-name="reportType" :data-vv-as="label.reportType" :error-messages="errors.collect('reportType')" v-validate="'required'"></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg6>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <div v-if="form.reportType === 'busCls'">
            <BusinessClass></BusinessClass>
          </div>
          <div v-if="form.reportType === 'ocpCls'">
            <OccupationClass></OccupationClass>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import BusinessClass from './BusinessClass'
import OccupationClass from './OccupationClass'

export default {
  data() {
    return {
      label: {
        reportType: 'Report Type'
      },
      form: {
        reportType: 'busCls'
      },
      reportTypes: [
        { label: 'Premium Analysis by Business Class', value: 'busCls' },
        { label: 'Premium Analysis by Occupation Class', value: 'ocpCls' }
      ],
      panel: [0]
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    BusinessClass,
    OccupationClass
  }
}
</script>

<style>

</style>
